export function categoryItemsHavePhoto(items) {
  return items.some(function (_ref) {
    var image = _ref.image,
      gatsbyImage = _ref.gatsbyImage;
    return gatsbyImage || image;
  });
}